import { editorOrAbovePolicy } from "./common";

/** Index Worker リソースのポリシー定義です。 */
export const IW_POLICIES = {
  /** プロジェクトの作成・並び替えなど編集操作の可否を判定します。 */
  "iw-project:edit": editorOrAbovePolicy,
  /** ジョブ（Index Worker）の追加・並び替え操作の可否を判定します。 */
  "iw-job:edit": editorOrAbovePolicy,
  /** Search Console プロパティの追加・削除可否を判定します。 */
  "iw-search-console:edit": editorOrAbovePolicy,
} as const;
